import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RouteUtil} from '../../util/route.util';
import {DomainsComponent} from './domains/domains.component';
import {BusinessesComponent} from './businesses/businesses.component';
import {RolesComponent} from './roles/roles.component';
import {RolePermissionsComponent} from './role-permissions/role-permissions.component';
import {UsersComponent} from './users/users.component';
import {AttributeTypesComponent} from './attribute-types/attribute-types.component';
import {AttributesComponent} from './attributes/attributes.component';
import {MenuComponent} from './menu/menu.component';
import {DeliveryMethodsComponent} from './delivery-methods/delivery-methods.component';
import {ServicesComponent} from './services/services.component';
import {TagsComponent} from './tags/tags.component';
import {AdditivesComponent} from './additives/additives.component';
import {PaymentMethodsComponent} from './payment-methods/payment-methods.component';
import {FactorsComponent} from './factors/factors.component';
import {OrdersComponent} from './orders/orders.component';
import {SpacesComponent} from './spaces/spaces.component';
import {AddOrUpdateServicesComponent} from './add-or-update-services/add-or-update-services.component';
import {AddOrUpdateDomainComponent} from './add-or-update-domain/add-or-update-domain.component';
import {OpenFactorsComponent} from './open-factors/open-factors.component';
import {UserDetailComponent} from './user-detail/user-detail.component';
import {HomeComponent} from './home/home.component';
import {PlaceOrderComponent} from './place-order/place-order.component';
import {Comments} from './comments/comments';
import {SettingsComponent} from './settings/settings.component';

const routes: Routes = [{
  path: RouteUtil.HOME_COMPONENT,
  component: HomeComponent
}, {
  path: RouteUtil.ATTRIBUTE_TYPES_COMPONENT,
  component: AttributeTypesComponent
}, {
  path: RouteUtil.ATTRIBUTES_COMPONENT,
  component: AttributesComponent
}, {
  path: RouteUtil.BUSINESSES_COMPONENT,
  component: BusinessesComponent
}, {
  path: RouteUtil.Menu_COMPONENT,
  component: MenuComponent
}, {
  path: RouteUtil.DIALOG_MODULE,
  loadChildren: () => import('./dialog/dialog.module').then(module => module.DialogModule)
}, {
  path: RouteUtil.DOMAINS_COMPONENT,
  component: DomainsComponent
}, {
  path: RouteUtil.ROLE_PERMISSIONS_COMPONENT,
  component: RolePermissionsComponent
}, {
  path: RouteUtil.ROLES_COMPONENT,
  component: RolesComponent
}, {
  path: RouteUtil.STAFFS_COMPONENT,
  component: UsersComponent
}, {
  path: RouteUtil.CLIENTS_COMPONENT,
  component: UsersComponent
}, {
  path: RouteUtil.DELIVERY_METHODS_COMPONENT,
  component: DeliveryMethodsComponent
}, {
  path: RouteUtil.SERVICES_COMPONENT,
  component: ServicesComponent
}, {
  path: RouteUtil.TAGS_COMPONENT,
  component: TagsComponent
}, {
  path: RouteUtil.ADDITIVES_COMPONENT,
  component: AdditivesComponent
}, {
  path: RouteUtil.PAYMENT_METHODS_COMPONENT,
  component: PaymentMethodsComponent
}, {
  path: RouteUtil.FACTORS_COMPONENT,
  component: FactorsComponent
}, {
  path: RouteUtil.ORDERS_ADMIN_COMPONENT,
  component: OrdersComponent
}, {
  path: RouteUtil.ADD_OR_UPDATE_SERVICE_COMPONENT,
  component: AddOrUpdateServicesComponent
}, {
  path: RouteUtil.SPACES_COMPONENT,
  component: SpacesComponent
}, {
  path: RouteUtil.ADD_OR_UPDATE_DOMAIN_COMPONENT,
  component: AddOrUpdateDomainComponent
}, {
  path: RouteUtil.OPEN_FACTORS_COMPONENT,
  component: OpenFactorsComponent
}, {
  path: RouteUtil.USER_DETAIL_COMPONENT,
  component: UserDetailComponent
}, {
  path: RouteUtil.PLACE_ORDER_COMPONENT + '/:userId',
  component: PlaceOrderComponent
}, {
  path: RouteUtil.PLACE_ORDER_COMPONENT,
  component: PlaceOrderComponent
}, {
  path: RouteUtil.COMMENTS_COMPONENT,
  component: Comments
}, {
  path: RouteUtil.SETTINGS_COMPONENT,
  component: SettingsComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule {
}
